import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/landing/landing.component').then(m => m.LandingComponent),
  },
  {
    path: 'main',
    loadComponent: () =>
      import('./features/main/main.component').then(m => m.MainComponent),
  },
  {
    path: 'choose-module',
    loadComponent: () =>
      import('./features/tabular/upload-module/upload-module.component').then(m => m.UploadModuleComponent),
  },
  {
    path: 'data-profiling-module',
    loadComponent: () =>
      import('./features/tabular/data-profiling-module/data-profiling-module.component').then(m => m.DataProfilingModuleComponent),
  },
  {
    path: 'profiling-variable-edit/:dataset/:variable',
    loadComponent: () =>
      import('./features/tabular/profiling-variable-edit/profiling-variable-edit.component').then(m => m.ProfilingVariableEditComponent),
  },
  {
    path: 'strategy-planning-module',
    loadComponent: () =>
      import('./features/tabular/strategy-planning-module/strategy-planning-module.component').then(m => m.StrategyPlanningModuleComponent),
  },
  {
    path: 'execution-module',
    loadComponent: () =>
      import('./features/tabular/execution-module/execution-module.component').then(m => m.ExecutionModuleComponent),
  },
  {
    path: 'validation-module',
    loadComponent: () =>
      import('./features/tabular/validation-module/validation-module.component').then(m => m.ValidationModuleComponent),
  },
  // {
  //   path: 'images',
  //   loadComponent: () =>
  //     import('./features/images/images.component').then(m => m.ImagesComponent),
  // },

  // ── Omics pipeline (mockups) — DISABLED on this branch ──────
  // This branch ships the tabular pipeline only. The omics feature code under
  // features/omics/ and services/omics/ is untouched and still compiles; only its
  // routes are off, so nothing can navigate to it. Uncomment this block (and the
  // omics card + run-history drawer in features/main/main.component.html) to
  // restore it.
  //
  // Four user-facing stages; see OMICS_STEPS in shared/constants/steps.ts.
  // omics-choose-module sits before them, same as choose-module does for the
  // tabular pipeline, and is not one of the four stages.
  // {
  //   path: 'omics-choose-module',
  //   loadComponent: () =>
  //     import('./features/omics/choose-module/omics-choose-module.component').then(m => m.OmicsChooseModuleComponent),
  // },
  // {
  //   path: 'omics-ingestion',
  //   loadComponent: () =>
  //     import('./features/omics/ingestion-module/omics-ingestion-module.component').then(m => m.OmicsIngestionModuleComponent),
  // },
  // {
  //   path: 'omics-strategy',
  //   loadComponent: () =>
  //     import('./features/omics/strategy-module/omics-strategy-module.component').then(m => m.OmicsStrategyModuleComponent),
  // },
  // {
  //   path: 'omics-processing',
  //   loadComponent: () =>
  //     import('./features/omics/processing-module/omics-processing-module.component').then(m => m.OmicsProcessingModuleComponent),
  // },
  // {
  //   path: 'omics-analysis',
  //   loadComponent: () =>
  //     import('./features/omics/analysis-module/omics-analysis-module.component').then(m => m.OmicsAnalysisModuleComponent),
  // },
  {
    path: 'review-all',
    data: { mode: 'all' },
    loadComponent: () =>
      import('./features/tabular/variable-review/variable-review.component').then(m => m.VariableReviewComponent),
  },
  {
    path: 'review/:index',
    data: { mode: 'single' },
    loadComponent: () =>
      import('./features/tabular/variable-review/variable-review.component').then(m => m.VariableReviewComponent),
  },
  {
    path: 'review-human-intervention',
    data: { mode: 'human' },
    loadComponent: () =>
      import('./features/tabular/variable-review/variable-review.component').then(m => m.VariableReviewComponent),
  },
  {
    path: 'review-unreviewed',
    data: { mode: 'unreviewed' },
    loadComponent: () =>
      import('./features/tabular/variable-review/variable-review.component').then(m => m.VariableReviewComponent),
  },
  { path: '**', redirectTo: '' },
];
